export const EDIT_PRODUCT_QUERY = `
query EditProductQuery($productId: ID!) { 
  templates { 
  \tid
    name
    characteristics { 
    \tid
      shortcut
   \t\tlocalizedKey
      dataType
      order
    }
  }
  characteristics { 
  \tid
    shortcut
    category
    unit {name}
    localizedKey
    dataType
    masterSort
  }
\tproduct(productId: $productId) { 
  \tid 
    description
    productCharacteristics { 
    \tid
      shortcut
      localizedKey
      unit {name}
      category
      dataType
    }
    properties { 
    \tstringValue { 
      \tid 
        propertyType
        value
      }
      singleValue { 
      \tid
        propertyType
        name
        propertyId
      }
      multpileValues { 
      \tid
        propertyType
        values { 
        \tid 
          propertyType
          name
          propertyId
        }
      }
    }
    templates { 
    \tid
      name
      productTemplateCharacteristics { 
      \tid 
        shortcut
        localizedKey
      \tvalue1
        value2
        dataType
        order
      }
    }
  }

}
`
